import { QueryClient, useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { messageError, messagePending, messageSuccess } from "../../../services/messages";
import { apiErrorMessage } from "../../../services/apiErrorText"
import { addLogoToCompanySettings, updateCompanyData } from "./apiCalls";
import { CompanySettingsType } from "../types";
import { GeneralQueryKeys } from "../../../api/constants";


// Update Company Data
export const useUpdateCompanyData = (queryClient: QueryClient, queryKey: string) => {
    const [notificationKey, setnotificationKey] = useState<string>("")
    const mutation = useMutation<unknown, Error, CompanySettingsType>({
        mutationFn: updateCompanyData,
        onMutate: () => {
            const newKey = Math.random().toString(36).substring(2, 12)
            setnotificationKey(newKey)
            messagePending(newKey, "In Bearbeitung...", "Die Einstellungen werden gerade aktualisiert.")
        },
        onSuccess: () => {
            messageSuccess(notificationKey, "Fertig!", "Die Einstellungen wurden erfolgreich aktualisiert.")
            console.log(queryKey)   
            queryClient.invalidateQueries({
                queryKey: [queryKey, GeneralQueryKeys.COMPANY_DATA_LOGO],
            })
        },
        onError: (err) => {
            messageError(notificationKey, "Fehler!", apiErrorMessage(err, "Die Einstellungen konnten nicht aktualisiert werden."))
            console.log(err)
        },
    })

    return mutation
}


// Upload Logo
export const useUploadLogo = (queryClient: QueryClient, queryKey: string, setLoading: (e: boolean) => void) => {
    const [notificationKey, setnotificationKey] = useState<string>("")
    const mutation = useMutation<unknown, Error, { logo: FormData }>({
        mutationFn: addLogoToCompanySettings,
        onMutate: () => {
            const newKey = Math.random().toString(36).substring(2, 12)
            setnotificationKey(newKey)
            messagePending(newKey, "In Bearbeitung...", "Der Upload wird gerade durchgeführt.")
        },
        onSuccess: (data, variables) => {
            setLoading(false)
            messageSuccess(notificationKey, "Fertig!", "Upload erfolgreich durchgeführt.")
            queryClient.invalidateQueries({
                queryKey: [queryKey],
            })
        },
        onError: (err) => {
            messageError(notificationKey, "Fehler!", apiErrorMessage(err, "Der Upload ist fehlgeschlagen."))
            setLoading(false)
            console.log(err)
        },
    })

    return mutation
}
